import { ArrowLeftIcon, CloseIcon } from "@/assets/icons";

type ViewHeaderProps = {
  title: string;
  /** Closed off while a request is in flight, so a half-written save cannot be
   * walked away from. */
  isDisabled?: boolean;
  onBack: () => void;
  onClose: () => void;
};

/** Header of a sub-view: back to the hub on the left, close the whole dialog on the right. */
const ViewHeader = ({
  title,
  isDisabled = false,
  onBack,
  onClose
}: ViewHeaderProps) => (
  <div className="flex flex-row items-center justify-between">
    <div className="flex items-center gap-2">
      <button
        type="button"
        className="bg-transparent border-0 p-0 disabled:opacity-40 disabled:cursor-not-allowed"
        disabled={isDisabled}
        onClick={onBack}
        aria-label="Back"
        data-testid="data-settings-view-back-button"
      >
        <ArrowLeftIcon className="fill-dim-gray" />
      </button>
      <h2 className="text-txtHeading font-sans font-bold text-[20px]">
        {title}
      </h2>
    </div>
    <button
      type="button"
      className="bg-transparent border-0 p-0 disabled:opacity-40 disabled:cursor-not-allowed"
      disabled={isDisabled}
      onClick={onClose}
      aria-label="Close"
      data-testid="data-settings-view-close-button"
    >
      <CloseIcon className="fill-dim-gray" />
    </button>
  </div>
);

export default ViewHeader;
